import { render, staticRenderFns } from "./PrintTurn.vue?vue&type=template&id=cb7971da&scoped=true"
import script from "./PrintTurn.vue?vue&type=script&lang=js"
export * from "./PrintTurn.vue?vue&type=script&lang=js"
import style0 from "./PrintTurn.vue?vue&type=style&index=0&id=cb7971da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7971da",
  null
  
)

export default component.exports